const getEnvironment = process.env.REACT_APP_ENVIRONMENT

const isProductionEnvironment = getEnvironment === "PRODUCTION" ? true : false

// console.log("ENVIRONMENT " + getEnvironment)
// console.log("isProductionEnvironment " + isProductionEnvironment)

export {getEnvironment, isProductionEnvironment}